<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 38.82 26.77" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><path d="m30.19 16.94h5.68"/><path d="m36.12 5.93-10.19-4.16a17.3 17.3 0 0 0 -13 0l-10.19 4.16a3.53 3.53 0 0 0 -2 4.56l2.41 6.27v2.51h32.52v-2.51l2.41-6.27a3.55 3.55 0 0 0 -1.96-4.56z"/><path d="m3.33 16.94h24.38"/><path d="m19.43 19.21-16.24.06v-.07a1.8 1.8 0 0 0 -.45 1.07c0 2.7 7.42 6 16.56 6s16.57-3.26 16.57-6a1.87 1.87 0 0 0 -.4-1z"/><path d="m15.32 9.27a3.9 3.9 0 0 0 7.8 0"/><path d="m19.24 13.21v-7.21"/><circle cx="19.24" cy="4.9" r="1.19"/><path d="m17.31 8.49h3.86"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
